import { CheckmarkIcon } from "@/public/icons/CheckmarkIcon";
import styles from "./Advantage.module.scss";

export type AdvantageProps = {
  title: string;
  description: string;
};

export const Advantage = ({ title, description }: AdvantageProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.checkmark}>
        <CheckmarkIcon color={"#37837d"} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};
